var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kendo-datepicker',{key:_vm.key,attrs:{"value":_vm.content,"format":'dd/MM/yyyy',"culture":'it-IT',"today":'Oggi'},on:{"change":_vm.onChangeDate}})}
var staticRenderFns = []

export { render, staticRenderFns }